module.exports = {
  "country": "UK",
  "artist": "Mary Hopkin",
  "song": "Knock, Kock, Who´s There",
  "year": "1970",
  "place": "2",
  "spotify": "1hSVmo4Qm0ry3tmUBHCEqN"
};